module.exports = __webpack_public_path__ + "media/images/location-59bd56ae.png";